import color from "themes/foundations/color";
import { rgba } from "polished";

const gradientArray = [
    color.brand.darkOrange,
    color.brand.red,
    color.brand.purple,
    color.brand.mediumBlue,
];

interface GradientProps {
    position?: string;
    fromPercentage?: string;
    toPercentage?: string;
    backgroundSize?: string;
    animationDelay?: string;
    animationFillMode?: "forwards" | "backwards";
    duration?: string;
}

export const getRandomAnimatedGradient = (props: GradientProps) => {
    const random = Math.random();
    const randomIndex = Math.floor(random * gradientArray.length);
    const randomGradient = gradientArray[randomIndex];
    const randomRGBAGradient = rgba(randomGradient, 0.8);

    return {
        _before: {
            content: ['""', null, null, "none"],
            position: "absolute",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            PointerEvents: "none",
            backgroundImage: `radial-gradient(circle farthest-corner at bottom ${props.position}, ${randomRGBAGradient} 10%, rgba(255, 255, 255, 0.00) ${props.toPercentage})`,
            backgroundSize: props.backgroundSize,
        },
        backgroundImage: {
            lg: `radial-gradient(circle farthest-corner at bottom ${props.position}, ${randomRGBAGradient} 10%, rgba(255, 255, 255, 0.00) ${props.toPercentage})`,
        },
        backgroundSize: { lg: props.backgroundSize },
    };
};
